import { render, staticRenderFns } from "./discipline-explanatory-cell.vue?vue&type=template&id=63808e11&scoped=true&"
import script from "./discipline-explanatory-cell.vue?vue&type=script&lang=js&"
export * from "./discipline-explanatory-cell.vue?vue&type=script&lang=js&"
import style0 from "./discipline-explanatory-cell.vue?vue&type=style&index=0&id=63808e11&lang=scss&scoped=true&"
import style1 from "./discipline-explanatory-cell.vue?vue&type=style&index=1&id=63808e11&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63808e11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63808e11')) {
      api.createRecord('63808e11', component.options)
    } else {
      api.reload('63808e11', component.options)
    }
    module.hot.accept("./discipline-explanatory-cell.vue?vue&type=template&id=63808e11&scoped=true&", function () {
      api.rerender('63808e11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/data-table/discipline-explanatory-cell.vue"
export default component.exports